"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = {
  "popover-wrapper": "popover-wrapper_3eRU9D",
  "popoverWrapper": "popover-wrapper_3eRU9D",
  "container": "container_3BFAEg",
  "published": "published_2MsWI4",
  "development": "development_20eN9p",
  "deprecated": "deprecated_1EeluA",
  "lifecycle-state": "lifecycle-state_TC6ezV",
  "lifecycleState": "lifecycle-state_TC6ezV",
  "icon": "icon_2QeebU",
  "light-theme": "light-theme_1ZzZSP",
  "lightTheme": "light-theme_1ZzZSP"
}; 
require('./LifecycleStatePill.css');
var getStatusLabel = function getStatusLabel(status) {
  var _statusMap$status;
  var statusMap = {
    published: 'Stable',
    deprecated: 'Deprecated',
    development: 'Development'
  };
  return (_statusMap$status = statusMap[status]) !== null && _statusMap$status !== void 0 ? _statusMap$status : status;
};
var LifecycleStatePill = function LifecycleStatePill(_ref) {
  var status = _ref.status,
    _ref$lightTheme = _ref.lightTheme,
    lightTheme = _ref$lightTheme === void 0 ? false : _ref$lightTheme;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "pill-lifecycle-popover-wrapper",
    className: (0, _classnames.default)(styles.popoverWrapper, (0, _defineProperty2.default)({}, styles.lightTheme, lightTheme))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.container, styles[status]),
    "data-test-id": "pill-lifecycle-state"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.lifecycleState,
    "data-test-id": "pill-lifecycle-state-label"
  }, getStatusLabel(status))));
};
var _default = exports.default = LifecycleStatePill;
//# sourceMappingURL=LifecycleStatePill.js.map